import { render, staticRenderFns } from "./LeakageCauseRoomQuestion.vue?vue&type=template&id=03b74af7"
import script from "./LeakageCauseRoomQuestion.vue?vue&type=script&lang=ts"
export * from "./LeakageCauseRoomQuestion.vue?vue&type=script&lang=ts"
import style0 from "./LeakageCauseRoomQuestion.vue?vue&type=style&index=0&id=03b74af7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports